import EmailIcon from '@mui/icons-material/Email';
import { Alert, Box, Button, Paper, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

const ConfirmError: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [error, setError] = useState<boolean>(false);
  const theme = useTheme();
  const [hasParams, setHasParams] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if ([...searchParams].length === 0) {
      navigate('/', { replace: true });
      return;
    }
    setHasParams(true);
    const err = searchParams.get('err');
    setError(err === 'true');

    setSearchParams({});
    // Only run this logic once
    // eslint-disable-next-line
  }, []);

  if (!hasParams) return null;

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', mt: 4, p: 2 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 3,
          border: `1px solid ${theme.palette.divider}`,
          textAlign: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          {error && (
            <Box>
              <Alert severity="error">Unable to confirm email address</Alert>
              <Typography variant="body1" sx={{ mt: 2 }}>
                There was an error confirming your email address. <br /> Please
                try clicking the link again, or contact us at
              </Typography>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EmailIcon />}
                href={`mailto:${import.meta.env.VITE_REACT_APP_CONTACT_EMAIL}`}
                sx={{ mt: 2, fontWeight: 'bold', textTransform: 'none' }}
              >
                {import.meta.env.VITE_REACT_APP_CONTACT_TITLE}
              </Button>
            </Box>
          )}
          {!error && <Alert severity="success">Email Address Confirmed</Alert>}
        </Box>
      </Paper>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '20px',
          textAlign: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <Button sx={{ textTransform: 'none' }}>
          <Link to="/">Home</Link>
        </Button>
        <Button sx={{ textTransform: 'none' }}>
          <Link to="/notification">Email Notifications</Link>
        </Button>
      </Box>
    </Box>
  );
};

export default ConfirmError;
